<footer class="d-flex flex-column gap-3 align-items-md-center py-md-4 py-2 mb-6">
  <!--logo-->
  <a href="#" class="d-none d-lg-block">
    <picture>
      <source
        srcset="https://myhomesan.azureedge.net/media/myhome-cdn/brand-main-logo_360.webp?v=1.1"
        type="image/webp"
      />
      <source
        srcset="https://myhomesan.azureedge.net/media/myhome-cdn/brand-main-logo_360.jpg?v=1.1"
        type="image/jpeg"
      />
      <img
        class="navbar-logo footer-logo"
        src="https://myhomesan.azureedge.net/media/myhome-cdn/brand-main-logo_360.jpg?v=1.1"
        alt="myhome logo"
      />
    </picture>
  </a>

  <!--Socials icons-->
  <div class="align-items-center justify-content-center flex-nowrap my-auto d-flex">
    <div class="circle">
      <a
        rel="noopener"
        href="https://www.facebook.com/MyHome.ie"
        [attr.aria-label]="'Facebook'"
        class="social-icons"
        target="_blank"
      >
        <svg-icon
          src="https://myhomesan.azureedge.net/media/myhome-cdn/rebrand-assets/Icons/svg/icons-solid/social-facebook.svg"
        />
      </a>
    </div>
    <div class="circle">
      <a
        rel="noopener"
        href="https://www.instagram.com/MyHome.ie"
        [attr.aria-label]="'Instagram'"
        class="social-icons"
        target="_blank"
      >
        <svg-icon
          src="https://myhomesan.azureedge.net/media/myhome-cdn/rebrand-assets/Icons/svg/icons-solid/social-instagram-fill.svg"
        />
      </a>
    </div>
    <div class="circle">
      <a
        rel="noopener"
        href="https://x.com/myhomeproperty"
        [attr.aria-label]="'Twitter'"
        class="social-icons"
        target="_blank"
      >
        <svg-icon
          src="https://myhomesan.azureedge.net/media/myhome-cdn/rebrand-assets/Icons/svg/icons-solid/social-x.svg"
        />
      </a>
    </div>
    <div class="circle">
      <a
        rel="noopener"
        href="https://www.linkedin.com/company/myhome.ie/"
        [attr.aria-label]="'LinkedIn'"
        class="social-icons"
        target="_blank"
      >
        <svg-icon
          src="https://myhomesan.azureedge.net/media/myhome-cdn/rebrand-assets/Icons/svg/icons-solid/social-linkedin.svg"
        />
      </a>
    </div>
    <div class="circle">
      <a
        rel="noopener"
        href="https://www.tiktok.com/@myhome.ie"
        [attr.aria-label]="'Tiktok'"
        class="social-icons"
        target="_blank"
      >
        <svg-icon
          src="https://myhomesan.azureedge.net/media/myhome-cdn/rebrand-assets/Icons/svg/icons-solid/social_tiktok.svg"
        />
      </a>
    </div>
    <!--youtube icon-->
    <div class="circle d-none d-lg-block">
      <a
        rel="noopener"
        href="https://www.youtube.com/@myhomeie"
        [attr.aria-label]="'YouTube'"
        class="social-icons"
        target="_blank"
      >
        <svg-icon
          src="https://myhomesan.azureedge.net/media/myhome-cdn/rebrand-assets/Icons/svg/icons-solid/social-youtube.svg"
        />
      </a>
    </div>
  </div>
  <!--main footer-->
  <div class="footer-links">
    <div class="order-0">
      <a class="footer__link footer__link text-wrap text-xl-nowrap d-flex justify-content-center" href="help"> Help</a>
    </div>
    <div class="order-0">
      <a class="footer__link text-nowrap d-flex justify-content-center" href="jobs">Jobs </a>
    </div>
    <div class="order-0">
      <a class="footer__link text-wrap text-xl-nowrap d-flex justify-content-center" href="about">About </a>
    </div>
    <div class="order-1 order-md-2">
      <a class="footer__link text-wrap text-xl-nowrap d-flex justify-content-center" href="contact">Contact </a>
    </div>
    <div class="spacer order-2 d-none d-lg-block"></div>
    <div class="order-2 order-md-1">
      <a
        class="footer__link text-wrap text-xl-nowrap d-flex justify-content-center"
        href="https://news.myhome.ie/uncategorized/property-advertisement-equality-guidelines-22866"
      >
        Equality Guidelines
      </a>
    </div>
    <div class="order-2 order-md-1">
      <a class="footer__link text-wrap text-xl-nowrap d-flex justify-content-center" href="brandsafety"
        >Brand Safety
      </a>
    </div>

    <div class="order-3">
      <a
        target="_blank"
        class="footer__link text-nowrap d-flex justify-content-center"
        href="https://news.myhome.ie/uncategorized/terms-and-conditions-36589"
        >Terms & Conditions
      </a>
    </div>
    <div class="order-3">
      <a
        target="_blank"
        class="footer__link text-wrap text-xl-nowrap d-flex justify-content-center"
        href="https://news.myhome.ie/uncategorized/cookie-policy-36623"
        >Cookie Policy
      </a>
    </div>

    <div class="order-3">
      <!-- <a
        id="ot-sdk-btn"
        class="footer__link text-wrap text-xl-nowrap d-flex justify-content-center ot-sdk-show-settings"
        (click)="cookieSettings()"
        >Cookie Settings</a
      > -->
    </div>
    <div class="order-3">
      <a
        target="_blank"
        class="footer__link text-wrap text-xl-nowrap d-flex justify-content-center"
        href="https://news.myhome.ie/uncategorized/privacy-policy-36583 "
        >Privacy Policy
      </a>
    </div>

    <div class="order-3">
      <a
        class="footer__link text-wrap text-xl-nowrap d-flex justify-content-center"
        href="https://news.myhome.ie/uncategorized/digital-services-act-32106"
        >Digital Services Act
      </a>
    </div>
    <div class="order-3">
      <a class="footer__link text-wrap text-xl-nowrap d-flex justify-content-center" href="sitemap">Sitemap </a>
    </div>
  </div>
  <!-- row-2 -->

  <!-- Copyright -->
  <div class="footer-text text-center mb-5">© Copyright MyHome {{ currentYear }}</div>
</footer>
